'use client';

import classNames from 'classnames';
import style from './Switch.module.scss';

const Switch = ({
  switchText,
  handleSwitch,
  black,
  grey,
  type,
  href,
  someStyles,
  testId,
  white,
  transparent,
  disabled = false,
  target = '_blank',
}) => {
  const btnClass = classNames(
    style.switch,
    {
      [style.dark_switch]: black,
      [style.dark_grey]: !black && !grey,
      [style['dark_lightdark-grey']]: grey,
      [style.white]: white,
      [style.transparent]: transparent,
    },
    someStyles,
  );

  if (type === 'link') {
    return (
      <a href={href} target={target} rel='noreferrer' className={btnClass}>
        {switchText}
      </a>
    );
  }

  return (
    <button className={btnClass} onClick={handleSwitch} data-testid={testId} disabled={disabled}>
      {switchText}
    </button>
  );
};

export default Switch;
